import { configureStore } from '@reduxjs/toolkit';
import workspaceReducer from './workspaceSlice';
import fileReducer from './fileSlice';
import versionReducer from './versionSlice';
import logReducer from './logSlice';

export const store = configureStore({
  reducer: {
    workspace: workspaceReducer,
    file: fileReducer,
    version: versionReducer,
    log: logReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
